import DOMManager from "./DOM.manager";
import config from "../scripts/config";

let inputArea = null

export default class TextareaManager {

    static init(input){
        if(input != null){
            inputArea = input
        }else {
            inputArea = document.getElementById(config.DEFAULT_MESSAGE_AREA_ID)
        }
    }
    static appendElement(toAdd) {
        if (toAdd) {
            inputArea.appendChild(toAdd);
        }
    }

    static AddToCursor(toAdd){
        // case remove everything
        if(inputArea.childNodes.length == 0){
            let pargraph = document.createElement("p")
            inputArea.appendChild(pargraph)
            DOMManager.RestartCursor()
        }

        let cursor = DOMManager.getCursor()
        if(cursor == null){
            DOMManager.RestartCursor()
            cursor = DOMManager.getCursor()
        }

        if(typeof cursor.endContainer != 'undefined'){
            DOMManager.ReplaceNode(cursor, toAdd)
        }else {
            if(typeof cursor.startContainer != 'undefined'){ // after user action type , click
                if(cursor.startContainer.nodeName == "#text"){
                    TextareaManager.HandleText(cursor, toAdd)
                }else if(cursor.startContainer.nodeName == "P"){     // first element
                    if(inputArea.childNodes[0].innerText == cursor.startContainer.innerText){
                        inputArea.childNodes[0].appendChild(toAdd)
                    }
                }
            }else {
                // before user action type , click
                inputArea.childNodes[0].appendChild(toAdd)
                inputArea.classList.remove('empty')
            }
        }
        // This remove the whiste spaces... is that the behavior needed?
        // inputArea.innerHTML = inputArea.innerHTML.replace(/&nbsp;/g, ' ')
        TextareaManager.MoveCursorAfterAdd(toAdd)
    }

    static ReplaceAddedMention(toAdd, mention_id){
            if(typeof inputArea.childNodes[0].dataset != 'undefined'&&
                inputArea.childNodes[0].dataset.id === mention_id){
                inputArea.childNodes[0].innerText = toAdd
        }
    }

    static MoveCursorAfterAdd(toAdd, specificLength = 0){
        let range = document.createRange()
        let sel = window.getSelection()
        let dataID = ''
        let MentionPosition = 0
        let EmojiPosition = 0

        if(inputArea == null){
            inputArea = document.getElementById(config.DEFAULT_MESSAGE_AREA_ID)
        }

        switch (true) {
            case toAdd == null:
                let last_text_child = TextareaManager.getLastTextChild(inputArea.childNodes[0])
                //TODO(Alex); This doesn't make sense, the variable is null and then it's used (?)
                // if(last_text_child == null){    // doesn't has text children
                //     range.setStartAfter(last_text_child.childNodes[last_text_child.childNodes.length-1])
                //     DOMManager.setCursor(last_text_child.childNodes[last_text_child.childNodes.length],0)
                // }else
                // {
                if (last_text_child) {
                    range.setStart(last_text_child, last_text_child.length)
                    DOMManager.setCursor(last_text_child, last_text_child.length,0)
                }
                // }
                break
            case toAdd.nodeName == '#text':
                let cursor = DOMManager.getCursor()
                if(cursor.startContainer.nodeName == "P"){
                    if(typeof inputArea.childNodes[0].childNodes[0] != 'undefined'){
                        range.setStart(inputArea.childNodes[0].childNodes[0], cursor.startOffset)
                    }
                    else {
                        inputArea.childNodes[0].appendChild(toAdd)
                        range.setStart(inputArea.childNodes[0].childNodes[0], cursor.startOffset)
                    }
                    break
                }
                cursor.startContainer.textContent +=toAdd.textContent
                for(let i=0; i <inputArea.childNodes[0].childNodes.length;i++){
                    if(inputArea.childNodes[0].childNodes[i].textContent.trim() == cursor.startContainer.textContent.trim()){
                        range.setStart(inputArea.childNodes[0].childNodes[i], cursor.startOffset)
                        break
                    }

                    // if(inputArea.childNodes[0].childNodes[i].textContent.trim() != cursor.startContainer.textContent.trim() &&
                    //     i == inputArea.childNodes[0].childNodes.length -1 ){
                    //         range.setStart(inputArea.childNodes[0].childNodes[i], cursor.startOffset)
                    // }
                }
                break
            case toAdd.nodeName == 'SPAN':
                dataID = toAdd.dataset.id
                MentionPosition = TextareaManager.getChildPositionByDataID(dataID)
                if(MentionPosition == null){
                        for(let j=0; j<inputArea.childNodes[0].childNodes.length;j++){

                            let textAfterAdd = ''
                            if(toAdd.dataset.type == "user"){
                                textAfterAdd = DOMManager.getCursor().startContainer.textContent +" @"
                            }
                            if(toAdd.dataset.type == "file" || toAdd.dataset.type == "folder"){
                                textAfterAdd = DOMManager.getCursor().startContainer.textContent +" $"
                            }
                            if( textAfterAdd == inputArea.childNodes[0].childNodes[j].textContent){
                                MentionPosition = {
                                    "row": 0,
                                    "col": j+1
                                }
                                DOMManager.insertAfter(toAdd, inputArea.childNodes[0].childNodes[j])
                                break
                            }


                            if(inputArea.childNodes[0].childNodes[j].textContent.indexOf(textAfterAdd) > -1){ // in between text
                                let rest_text = document.createTextNode("")
                                rest_text.textContent = inputArea.childNodes[0].childNodes[j].textContent.slice(DOMManager.getCursor().startOffset+3) // 3 because " @"
                                DOMManager.insertAfter(rest_text, inputArea.childNodes[0].childNodes[j])
                                inputArea.childNodes[0].childNodes[j].textContent = inputArea.
                                                            childNodes[0].childNodes[j].textContent.slice(0,DOMManager.getCursor().startOffset+3)  // 3 because " @"

                                DOMManager.insertAfter(toAdd, inputArea.childNodes[0].childNodes[j])
                                MentionPosition = {
                                    "row": 0,
                                    "col": j+1
                                }
                                break

                            }

                    }
                }

                if(MentionPosition != null && toAdd.dataset.type == "user"){
                    // removing @
                    let username = toAdd.innerText
                    if(typeof inputArea.childNodes[0].childNodes[MentionPosition.col-1] != 'undefined'){
                        if(inputArea.childNodes[0].childNodes[MentionPosition.col-1].textContent.indexOf(username) > -1 ||
                            inputArea.childNodes[0].childNodes[MentionPosition.col-1].textContent.indexOf('@') > -1){
                                let position_at = -1
                                if(inputArea.childNodes[0].childNodes[MentionPosition.col-1].textContent.indexOf(username) > -1){
                                    position_at = inputArea.childNodes[0].childNodes[MentionPosition.col-1].textContent.indexOf(username)
                                }else {
                                    position_at = inputArea.childNodes[0].childNodes[MentionPosition.col-1].textContent.lastIndexOf("@")
                                }
                            inputArea.childNodes[0].childNodes[MentionPosition.col-1].textContent = inputArea.
                            childNodes[0].childNodes[MentionPosition.col-1].
                            textContent.slice(0, position_at)
                        }
                    }
                }

                if(MentionPosition != null && (toAdd.dataset.type == "file" || toAdd.dataset.type == "folder")){
                    // removing $
                    let ff_name = toAdd.innerText
                    if(typeof inputArea.childNodes[0].childNodes[MentionPosition.col-1] != 'undefined'){
                        if(inputArea.childNodes[0].childNodes[MentionPosition.col-1].textContent.indexOf(ff_name) > -1 ||
                            inputArea.childNodes[0].childNodes[MentionPosition.col-1].textContent.indexOf('$') > -1){
                            let position_at = -1
                            if(inputArea.childNodes[0].childNodes[MentionPosition.col-1].textContent.indexOf(ff_name) > -1){
                                position_at = inputArea.childNodes[0].childNodes[MentionPosition.col-1].textContent.indexOf(ff_name)
                            }else {
                                position_at = inputArea.childNodes[0].childNodes[MentionPosition.col-1].textContent.lastIndexOf("$")
                            }
                            inputArea.childNodes[0].childNodes[MentionPosition.col-1].textContent = inputArea.
                            childNodes[0].childNodes[MentionPosition.col-1].
                            textContent.slice(0, position_at)
                        }
                    }
                }
                // space after
                //@Warning this space could cause a problem because of &nbsp;
                // if (toAdd.dataset.type == "emoji") { break; }
                let text = document.createTextNode("\u00A0")
                if(MentionPosition != null && MentionPosition.col-1 >=0){
                    DOMManager.insertAfter(text, inputArea.childNodes[0].childNodes[MentionPosition.col])
                    range.setStart(inputArea.childNodes[0].childNodes[MentionPosition.col+1], 1)
                    DOMManager.setCursor(inputArea.childNodes[0].childNodes[MentionPosition.col+1],1)
                }else {
                    inputArea.childNodes[0].appendChild(text)
                    //TODO(Alex): Sometimes has the error that setStart first parameter is not a Node
                    if (inputArea.childNodes[0].childNodes[1]) {
                        range.setStart(inputArea.childNodes[0].childNodes[1], 1)
                        DOMManager.setCursor(inputArea.childNodes[0].childNodes[1],1)
                    }
                }
                break

            case toAdd.nodeName == 'IMG':
                dataID = toAdd.dataset.id
                EmojiPosition = TextareaManager.getChildPositionByDataID(dataID)
                EmojiPosition = EmojiPosition != null ? EmojiPosition : {col: 0}
                let emptyText = document.createTextNode("")
                inputArea.childNodes[0].appendChild(emptyText)
                range.setStart(inputArea.childNodes[0].childNodes[EmojiPosition.col+1], 0);

                // This is the space after
                text = document.createTextNode("\u00A0")
                if(EmojiPosition != null && EmojiPosition.col-1 >=0){
                    DOMManager.insertAfter(text, inputArea.childNodes[0].childNodes[EmojiPosition.col])
                    range.setStart(inputArea.childNodes[0].childNodes[EmojiPosition.col+1], 1)
                    DOMManager.setCursor(inputArea.childNodes[0].childNodes[EmojiPosition.col+1],1)
                }else {
                    inputArea.childNodes[0].appendChild(text)
                    //TODO(Alex): Sometimes has the error that setStart first parameter is not a Node
                    if (inputArea.childNodes[0].childNodes[1]) {
                        range.setStart(inputArea.childNodes[0].childNodes[1], 1)
                        DOMManager.setCursor(inputArea.childNodes[0].childNodes[1],1)
                    }
                }
                break

            case toAdd.nodeName == '#text':
                    for(let j=0; j < inputArea.childNodes[0].childNodes.length ;j++){ // cols
                        if(inputArea.childNodes[0].childNodes[j].textContent == toAdd.textContent){
                            range.setStart(inputArea.childNodes[0].childNodes[j], toAdd.textContent.length)
                        }
                    }
                break
            case Number.isInteger(toAdd):
                if(specificLength > 0){
                    range.setStart(inputArea.childNodes[0].childNodes[toAdd], specificLength)
                }else {
                    range.setStart(inputArea.childNodes[0], inputArea.childNodes[0].textContent.length)
                }
                break
            default:
                break;
        }
        range.collapse(true)
        sel.removeAllRanges()
        sel.addRange(range)
    }



    static getLastTextChild(element){
        let last_text = null
        if(typeof element != 'undefined' && typeof element.childNodes != 'undefined' && element.childNodes.length >= 0){
            for(let i = element.childNodes.length-1; i >= 0 ; i--){
                if(element.childNodes[i].nodeName == "P"||element.childNodes[i].nodeName == "#text"){
                    last_text =  element.childNodes[i]
                    break
                }
            }
        }else {
            return inputArea.childNodes[0].childNodes[inputArea.childNodes[0].childNodes.length -1]
        }
        return last_text
    }

    static getChildByDataID(ID){
            // here the pargraphs
            for(let j = 0; j < inputArea.childNodes[0].childNodes.length;j++){
                // here elements under pargraph
                if(typeof  inputArea.childNodes[0].childNodes[j].dataset != 'undefined' &&
                inputArea.childNodes[0].childNodes[j].dataset.id == ID){
                    return inputArea.childNodes[0].childNodes[j]
                }

            }

    }
    static getChildPositionByDataID(ID){
        let data = null
        for(let j = 0; j < inputArea.childNodes[0].childNodes.length;j++){
            // here elements under pargraph `cols`
            if(typeof  inputArea.childNodes[0].childNodes[j].dataset != 'undefined' &&
            inputArea.childNodes[0].childNodes[j].dataset.id == ID){
                data =  {"row": 0, "col": j, "node": inputArea.childNodes[0].childNodes[j]}
            }
        }

        if(data == null){
            let container = DOMManager.getCursor().startContainer
            if(inputArea.childNodes[0].childNodes[0] && inputArea.childNodes[0].childNodes[0].innerText == container.innerText){
                data = {"row": 0, "col": 0, "node": inputArea.childNodes[0].childNodes[inputArea.childNodes[0].childNodes.length -1]} // not ffound
            }
        }
        // console.log('position');
        return data
    }

    // text nodes always will be a children of children
    static HandleText(cursor, toAdd){
        /// after mention case
        if(cursor.startContainer.nodeName != '#text' &&
        typeof cursor.startContainer.parentNode != 'undefined' &&
        cursor.startContainer.previousSibling != null &&
        (cursor.startContainer.parentNode.classList.contains('mention_slag') ||
        (typeof cursor.startContainer.previousSibling != 'undefined' &&
        cursor.startContainer.previousSibling.classList.contains('mention_slag')))){
            let position = TextareaManager.getChildPositionByDataID(cursor.startContainer.previousSibling.dataset.id)
            let parentNode = cursor.startContainer.parentNode
            parentNode.insertBefore(toAdd,inputArea.childNodes[position.row].childNodes[position.col+2])       // +2 because insert before and the rest text
        }else {
            // After text case
            var sel, range;
            // In case of emojis, the inputArea lose the focus to select the icon
            // so it has to be restablished the focus and caret position
            TextareaManager.setCaretAtPosition(cursor.startContainer, cursor.startOffset);
            if (window.getSelection) {
                sel = window.getSelection();
                if (sel.getRangeAt && sel.rangeCount) {
                    range = sel.getRangeAt(0);
                    range.deleteContents();
                    range.insertNode( toAdd );
                    console.log('wee');
                }
            }
        }
    }

    static setCaretAtPosition(referenceNode, index) {
        inputArea.focus()
        let sel = window.getSelection();
        let range = sel.getRangeAt(0);
        range.setStart(referenceNode, index);
        range.collapse(true);
        sel.removeAllRanges();
        sel.addRange(range);
    }

    static isEmptyMessage(text){
        let CharArray = text.split('|')
        if(CharArray.length == 0){
            CharArray = text.split(' ')
        }
        for(let i =0; i < CharArray.length;i++){
            if(CharArray[i].replace(/[^\w-]/ig, '').length > 0 && CharArray[i] != '\n'){
                return false
            }
        }
        return true
    }


    static MoveCursorForStyle(style){
        let range = document.createRange()
        let sel = window.getSelection()
        for(let i=0; i <inputArea.childNodes[0].childNodes.length;i++){
            if(inputArea.childNodes[0].childNodes[i].textContent.indexOf(style)> -1){
                range.setStart(inputArea.childNodes[0].childNodes[i], inputArea.childNodes[0].childNodes[i].textContent.indexOf(style)+1)
                break
            }
        }
        range.collapse(true)
        sel.removeAllRanges()
        sel.addRange(range)
    }

    static getInputArea() {
        return inputArea;
    }
}
